<template>

    <v-container fluid v-if="this.condition()" >
      <a class="anchor" id="blocbilans"></a>
      <v-row dense>
        <v-col cols="12">
          <v-card elevation="2" height="416px" style="overflow:auto">
        <v-card-title><v-icon dense left color="teal">mdi-currency-eur</v-icon> Bilans et comptes de résultat</v-card-title>
        <v-card-text>
            <div v-if="$store.state.isDownloadingBilan.length > 0" class="bilanCacheDownloading">
              <div class="big-loader"></div>
              <div>Téléchargement du Bilan {{$store.state.isDownloadingBilan}} en cours</div>
            </div>

            <div v-if="1 == 0" class="dl-button"><i class="fas fa-chevron-down"></i> <!--<font-awesome-icon icon="fa-download"></font-awesome-icon>--></div>

                <div v-if="isProcessing()" style="text-align:justify;margin-top:15px;">
                    Certains bilans sont toujours en cours de téléchargement. Cela peut prendre plusieurs minutes.
                </div>

                <div v-for="b in getBilans()" :key="b.id">
                    <div v-if="b.path == 'processing'" class="dl-item">
                        <div>Chargement en cours...</div>
                        <div class="loader"></div>
                    </div>
                    <div v-else-if="b.path != 'Missing' && b.path != 'Error'" class="dl-item dl-item-fine" @click="downloadBilan(b.id, extractYear(b.name))">
                        <div>Bilan {{extractYear(b.name)}}.pdf</div>
                        <div>{{b.pages}} pages</div>
                        <div><i class="fas fa-download"></i></div>
                    </div>
                </div>

        </v-card-text>
    </v-card> </v-col> </v-row> </v-container>

</template>


<script>


export default {
  name: 'EtabBilansINPI',
  components: {
  },
  computed: {
  },
  methods: {
      getBilans() {
        return this.$store.getters.BilanInpiList
      },
      extractYear(str) {
        if (str == null)
          return ""
          var regex = str.match('_20.._')
          return regex[0].slice(1, -1)
      },
      extractSize(str) {
          str = str.replace(',', '.')
          return str.slice(1, -2) + " ko"
      },
      isProcessing () {
        var bilans = this.getBilans()
          for (var idx in bilans) {
              if (bilans[idx].path == 'processing') {
                  return true
              }
          }
        return false
      },
      downloadBilan (id, year) {
        var siret = this.$store.state.siret
        this.$store.dispatch('downloadBilan', {'siret': siret, 'id':id, 'year':year})
      },
      condition () {
          if (this.$store.getters.BilanInpiList === null) {
              return false
          }
          var bilans = this.$store.getters.BilanInpiList
          if (!bilans > 0)
            return false
          var cnt = 0
          for(var idx in bilans) {
              var b = bilans[idx]
              if (b.path != 'Missing' && b.path != 'Error')
                  cnt++
          }
          return cnt > 0
      }

  }
};
</script>


<style>
    .dl-button {
        padding: 5px;
        text-align: center;
        cursor: pointer;
        font-size: 16pt;
    }
    .dl-button:hover {
        background-color: #EEEEEE;
    }
    .dl-item {
        padding: 10px 10px;
        margin: 5px 0px;
        font-size: 12pt;
        display: flex;
        justify-content: space-between;
      color: black;
    }
    .dl-item-fine:hover {
        cursor: pointer;
        background-color: #EEEEEE;
    }
    .dl-item-fine:active {
        background-color: #d32f2f;
        color: white;
    }
    .loader {
        border: 5px solid #fff;
        border-top: 5px solid #d32f2f;
        border-bottom: 5px solid #d32f2f;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        animation: spin 2s linear infinite;
    }
    .bilanCacheDownloading {
      position: absolute;
      left: 0px;
      width: 100%;
      height: 80%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      color: #fff;
      font-weight: 500;
      font-size: 18pt;
    }
    .big-loader {
        border: 10px solid rgba(0, 0, 0, 0.0);
        border-top: 10px solid #d32f2f;
        border-bottom: 10px solid #d32f2f;
        border-radius: 50%;
        width: 150px;
        height: 150px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>